import {makeAutoObservable} from 'mobx';

import type {CardApiModel} from '../../../../api/payment';

export class CardModel {
  card: CardApiModel;

  constructor(card: CardApiModel) {
    this.card = card;

    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  get brand() {
    return this.card.card.brand;
  }

  get expMonth() {
    return this.card.card.exp_month;
  }

  get expYear() {
    return this.card.card.exp_year;
  }

  get last4Digits() {
    return this.card.card.last4;
  }
}
